import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hamburger", "cross"]

  toggle() {
    // Toggle between hamburger and cross icons
    if (this.hamburgerTarget.classList.contains("hidden")) {
      this.showHamburger()
    } else {
      this.showCross()
    }
  }

  showCross() {
    this.hamburgerTarget.classList.add("hidden")
    this.crossTarget.classList.remove("hidden")
  }

  showHamburger() {
    this.crossTarget.classList.add("hidden")
    this.hamburgerTarget.classList.remove("hidden")
  }
}